import { useMutation } from "@apollo/client";
import { Checkbox } from "@chakra-ui/react";
import {
  InternalAdminEditUserMutation,
  InternalAdminEditUserMutationVariables,
  InternalAdminUserFragment,
} from "gql/graphql";
import React, { memo, useCallback } from "react";
import colors from "app/colors";
import { isEmpty } from "lodash";
import INTERNAL_ADMIN_EDIT_USER_MUTATION from "../_networking/internal-admin-edit-user";

interface IProps {
  user: InternalAdminUserFragment;
}

const InternalAdminEditUserHideEmail = ({ user }: IProps) => {
  const [internalAdminEditUserMutationAPI] = useMutation<
    InternalAdminEditUserMutation,
    InternalAdminEditUserMutationVariables
  >(INTERNAL_ADMIN_EDIT_USER_MUTATION);

  const onHideToggled = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (user) {
        internalAdminEditUserMutationAPI({
          variables: {
            organizationId: user.organizationId,
            id: user.id,
            input: {
              isHideEmail: e.target.checked,
            },
          },
        });
      }
    },
    [internalAdminEditUserMutationAPI, user],
  );

  if (isEmpty(user.email)) return null;

  return (
    <Checkbox
      id="hideEmail"
      fontWeight={400}
      color={colors.gray50}
      defaultChecked={user.isHideEmail}
      onChange={onHideToggled}
      size="sm"
    >
      Hide
    </Checkbox>
  );
};

export default memo(InternalAdminEditUserHideEmail);
